import {combineReducers} from "redux";
import {smartBetReducer} from "./SmartBet/smartBetReducer";
import {smartBetsReducer} from "./SmartBet/smartBetsReducer";
import {generateSmartBetReducer} from "./SmartBet/generateSmartBetReducer";
import {smartbetTrackingReducer} from "./SmartBet/smartbetTrackingReducer";
import {quickbetReducer} from "./Quickbet/quickbetReducer";
import {quickbetsReducer} from "./Quickbet/quickbetsReducer";
import {quickbetReserveReducer} from "./Quickbet/quickbetReserveReducer";
import {quickbetCreateReducer} from "./Quickbet/quickbetCreateReducer";
import {quicktipReducer} from "./Quicktip/quicktipReducer";
import {quicktipsReducer} from "./Quicktip/quicktipsReducer";
import {quicktipCreateReducer} from "./Quicktip/quicktipCreateReducer";
import {quicktipReserveReducer} from "./Quicktip/quicktipReserveReducer";
import {quicktipTrackingReducer} from "./Quicktip/quicktipTrackingReducer";
import {confirmOTPReducer} from "./OTP/confirmOTPReducer";
import {operatorReducer} from "./Operator/operatorReducer";
import {superbetsReducer} from "./Superbet/superbetsReducer";
import {superbetReducer} from "./Superbet/superbetReducer";
import {superbetTrackingReducer} from "./Superbet/superbetTrackingReducer";
import {playerReducer} from "./Player/playerReducer"
import {historyReducer} from "./History/historyReducer"
import {shareTicketReducer} from "./History/shareTicketReducer";
import {calculationReducer} from "./Calculation/calculationReducer";
import {jackpotCreateReducer} from "./Jackpot/jackpotCreateReducer";
import {jackpotReducer} from "./Jackpot/jackpotReducer";
import {jackpotsReducer} from "./Jackpot/jackpotsReducer";
import {jackpotTrackingReducer} from "./Jackpot/jackpotTrackingReducer";
import {jackpotPickBetsReducer} from "./Jackpot/jackpotPickBetsReducer";
import {quickbetXCreateReducer} from './QuickbetX/quickbetXCreateReducer'
import {quickbetXReducer} from './QuickbetX/quickbetXReducer'
import {quickbetXReserveReducer} from './QuickbetX/quickbetXReserveReducer'
import {quickbetXsReducer} from './QuickbetX/quickbetXsReducer'
import {quickbetXTrackingReducer} from './QuickbetX/quickbetXTrackingReducer'
import {quickbetXFilterReducer} from "./QuickbetX/quickbetXFilterReducer";
import {encryptionReducer} from "./Encryption/encryptionReducer";
import {encryptionTGLinkReducer} from "./Encryption/encryptionTGLinkReducer";
import {paymentPawapayReducer} from "./Payments/paymentPawapayReducer";
import {postPawapayReducer} from "./Payments/postPaymentPawapayReducer";
import {diditInitReducer} from "./Payment/diditInitReducer";
import {authReducer} from "./Auth/authReducer";
import {authGuestReducer} from "./Auth/authGuestReducer";
import {getPlayerReducer} from "./Auth/getPlayerReducer";
import {refreshPlayerReducer} from "./Auth/refreshPlayerReducer";
import {confirmAuthOTPReducer} from "./Auth/confirmAuthOTPReducer";

export const rootReducer = combineReducers({
    paymentPawapayReducer:paymentPawapayReducer,
    postPawapayReducer: postPawapayReducer,
    smartBetReducer:smartBetReducer,
    smartBetsReducer:smartBetsReducer,
    generateSmartBetReducer:generateSmartBetReducer,
    smartbetTrackingReducer:smartbetTrackingReducer,
    quickbetReducer:quickbetReducer,
    quickbetReserveReducer:quickbetReserveReducer,
    quickbetCreateReducer:quickbetCreateReducer,
    quickbetsReducer:quickbetsReducer,
    quicktipReducer:quicktipReducer,
    quicktipsReducer:quicktipsReducer,
    quicktipCreateReducer:quicktipCreateReducer,
    quicktipReserveReducer:quicktipReserveReducer,
    quicktipTrackingReducer:quicktipTrackingReducer,
    confirmOTPReducer:confirmOTPReducer,
    operatorReducer:operatorReducer,
    superbetsReducer:superbetsReducer,
    superbetReducer:superbetReducer,
    superbetTrackingReducer:superbetTrackingReducer,
    playerReducer:playerReducer,
    historyReducer:historyReducer,
    shareTicketReducer:shareTicketReducer,
    calculationReducer:calculationReducer,
    jackpotCreateReducer:jackpotCreateReducer,
    jackpotReducer:jackpotReducer,
    jackpotsReducer:jackpotsReducer,
    jackpotTrackingReducer:jackpotTrackingReducer,
    jackpotPickBetsReducer:jackpotPickBetsReducer,
    quickbetXCreateReducer:quickbetXCreateReducer,
    quickbetXReducer:quickbetXReducer,
    quickbetXReserveReducer:quickbetXReserveReducer,
    quickbetXsReducer:quickbetXsReducer,
    quickbetXTrackingReducer:quickbetXTrackingReducer,
    quickbetXFilterReducer:quickbetXFilterReducer,
    encryptionReducer:encryptionReducer,
    encryptionTGLinkReducer:encryptionTGLinkReducer,
    authReducer:authReducer,
    diditInitReducer:diditInitReducer,
    getPlayerReducer:getPlayerReducer,
    authGuestReducer: authGuestReducer,
    confirmAuthOTPReducer:confirmAuthOTPReducer,
    refreshPlayerReducer:refreshPlayerReducer
});

export type RootState = ReturnType<typeof rootReducer>